var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGame2Badge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 392,
    viewBox: "0 0 392 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 371",
    filter: "url(#filter0_d_573_36)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 196,
    cy: 192,
    r: 192,
    fill: "#4E9783"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M173.298 274.812C135.636 274.812 95 267.352 95 250.938V239.996C95 237.509 96.9822 235.52 99.46 235.52C101.938 235.52 103.92 237.509 103.92 239.996V250.938C103.92 255.415 127.707 265.86 173.794 265.86C219.88 265.86 243.667 255.415 243.667 250.938V239.996C243.667 237.509 245.649 235.52 248.127 235.52C250.605 235.52 252.587 237.509 252.587 239.996V250.938C252.092 267.352 211.456 274.812 173.298 274.812Z",
    fill: "#026B4E",
    stroke: "#026B4E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M173.298 316.594C135.636 316.594 95 309.133 95 292.719V281.777C95 279.29 96.9822 277.301 99.46 277.301C101.938 277.301 103.92 279.29 103.92 281.777V292.719C103.92 297.196 127.707 307.641 173.794 307.641C219.88 307.641 243.667 297.196 243.667 292.719V281.777C243.667 279.29 245.649 277.301 248.127 277.301C250.605 277.301 252.587 279.29 252.587 281.777V292.719C252.092 309.133 211.456 316.594 173.298 316.594Z",
    fill: "#026B4E",
    stroke: "#026B4E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M205.506 206.176H141.579C139.101 206.176 137.119 204.187 137.119 201.7V132.067H110.854C109.368 132.067 107.386 131.072 106.89 129.58C106.394 128.088 106.394 126.099 107.386 125.104L170.321 51.4921C171.808 49.5026 175.277 49.5026 176.764 51.4921L239.204 125.104C240.195 126.596 240.69 128.088 239.699 129.58C239.204 131.072 237.222 132.067 235.735 132.067H209.47V201.7C209.966 204.187 207.984 206.176 205.506 206.176ZM146.039 197.223H201.046V127.591C201.046 125.104 203.028 123.114 205.506 123.114H226.815L173.295 60.9423L120.27 123.612H141.579C144.057 123.612 146.039 125.601 146.039 128.088V197.223V197.223Z",
    fill: "#026B4E",
    stroke: "#026B4E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M277.859 274.318C275.381 274.318 273.399 272.329 273.399 269.842V172.854C273.399 170.367 275.381 168.377 277.859 168.377H308.583L236.232 83.3258L217.896 105.21C216.41 107.2 213.436 107.2 211.95 105.708C209.968 104.216 209.968 101.231 211.454 99.7392L233.259 74.373C234.745 72.3835 238.214 72.3835 239.701 74.373L321.964 170.864C322.955 172.356 323.45 173.848 322.459 175.34C321.964 176.833 319.981 177.827 318.495 177.827H282.815V270.339C282.319 272.329 280.337 274.318 277.859 274.318Z",
    fill: "#026B4E",
    stroke: "#026B4E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M173.298 234.028C135.636 234.028 95 226.568 95 210.154C95 196.228 123.742 190.259 141.087 188.27C142.078 188.27 143.565 188.27 144.556 189.264C145.547 190.259 146.042 191.254 146.042 192.746V197.222H201.049V192.746C201.049 191.254 201.545 190.259 202.536 189.264C203.527 188.27 204.518 188.27 206.005 188.27C223.349 190.259 252.092 196.228 252.092 210.154C252.092 226.568 211.456 234.028 173.298 234.028ZM137.122 197.72C112.345 201.699 103.92 207.667 103.92 210.154C103.92 214.63 127.707 225.075 173.794 225.075C219.88 225.075 243.667 214.63 243.667 210.154C243.667 207.667 235.243 201.201 210.465 197.72V201.699C210.465 204.186 208.483 206.175 206.005 206.175H141.582C139.105 206.175 137.122 204.186 137.122 201.699V197.72Z",
    fill: "#026B4E",
    stroke: "#026B4E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M317.997 244.476C315.519 244.476 313.537 242.487 313.537 240V205.183C313.537 202.697 315.519 200.707 317.997 200.707C320.475 200.707 322.457 202.697 322.457 205.183V240C322.457 242.487 320.475 244.476 317.997 244.476Z",
    fill: "#026B4E",
    stroke: "#026B4E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M110.857 168.874C108.379 168.874 106.396 166.884 106.396 164.397V151.963C106.396 149.476 108.379 147.486 110.857 147.486C113.334 147.486 115.317 149.476 115.317 151.963V164.397C115.317 166.884 113.334 168.874 110.857 168.874Z",
    fill: "#026B4E",
    stroke: "#026B4E",
    strokeWidth: 2
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_573_36",
    x: 0,
    y: 0,
    width: 392,
    height: 392,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_36"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_36",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame2Badge);
export default __webpack_public_path__ + "static/media/game2-badge.e267631349c7a556353eac7f0713e421.svg";
export { ForwardRef as ReactComponent };